import * as d3 from 'd3';
import $ from 'jquery';

function wrap(text, width, x = 0) {
    text.each(function () {
        const text = d3.select(this);
        const words = text.text().split(/\s+/).reverse();
        const lineHeight = 1.1; // ems
        const y = text.attr('y');
        const dy = parseFloat(text.attr('dy'));
        let lineNumber = 0;
        let word = words.pop();
        let line = [];
        let tspan = text.text(null)
            .append('tspan')
            .attr('x', x)
            .attr('y', y)
            .attr('dy', dy + 'em');

        while (word) {
            line.push(word);
            tspan.text(line.join(' '));
            if (tspan.node().getComputedTextLength() > width) {
                line.pop();
                tspan.text(line.join(' '));
                line = [word];
                tspan = text.append('tspan').attr('x', x).attr('y', y).attr('dy',
                    ++lineNumber * lineHeight + dy + 'em'
                ).text(word);
            }
            word = words.pop();
        }
        text.style('transform', `translate(0, ${-7.5 * lineNumber}px)`);
    });
}

const formatValue = (value) => value.toFixed(0).replace(/\d(?=(\d{3})+$)/g, '$&,');

const createPieChart = (selector, data, colors = ['#f37e36', '#fbc02d']) => {
    let height = 260;
    let fontSize1 = '14px';
    let fontSize2 = '12px';

    if ($(window).width() < 500) {
        height = 150;
        fontSize1 = '11px';
        fontSize2 = '10px';
    }

    const radius = height / 2;

    if (d3.select(selector).node()) {
        d3.select(selector).selectAll('svg').remove();

        const svg = d3.select(selector)
            .append('svg')
            .attr('class', 'w-100 overflow-visible')
            .attr('height', `${height}`)
            .append('g')
            .style('transform', 'translate(50%, 50%)');
        svg.append('g').attr('class', 'lines');
        svg.append('g').attr('class', 'pie');
        svg.append('g').attr('class', 'labels');

        const color = d3.scaleOrdinal()
            .domain(data.map(el => el.label))
            .range(colors);
        const pie = d3.pie().sort(null).value(d => d.value);
        const dataReady = pie(data);

        const arc = d3.arc().innerRadius(0).outerRadius(radius * 0.9);
        const outerArc = d3.arc().innerRadius(radius * 0.95).outerRadius(radius * 0.95);

        /* ------- PIE SLICES -------*/
        svg.select('.pie').selectAll('whatever')
            .data(dataReady, d => d.data.label)
            .enter()
            .append('path')
            .attr('d', arc)
            .attr('fill', d => color(d.data.label))
            .attr('stroke', 'black')
            .style('stroke-width', '1px')
            .exit()
            .remove();

        /* ------- TEXT LABELS -------*/

        const text = svg.select('.labels').selectAll('whatever')
            .data(dataReady, d => d.data.label)
            .enter()
            .append('text')
            .attr('dy', '.35em')
            .attr('transform', d => {
                const pos = outerArc.centroid(d);
                pos[0] = radius * (d.startAngle + (d.endAngle - d.startAngle) / 2 < Math.PI ? 1 : -1);
                return 'translate('+ pos +')';
            })
            .style('text-anchor', d => (
                d.startAngle + (d.endAngle - d.startAngle) / 2 < Math.PI ? 'start' : 'end'
            ))
            .style('font-size', fontSize1);

        text.append('tspan')
            .text(d => `${d.data.label}: `);
        text.append('tspan')
            .style('font-size', fontSize2)
            .style('fill', '#838383')
            .text(d => formatValue(d.data.value));
        text.exit().remove();

        /* ------- SLICE TO TEXT POLYLINES -------*/

        svg.select('.lines')
            .selectAll('whatever')
            .data(pie(data), d => d.data.label)
            .enter()
            .append('polyline')
            .style('fill', 'none')
            .style('stroke', 'black')
            .style('stroke-width', '1px')
            .style('opacity', 0.3)
            .attr('points', d => {
                const pos = outerArc.centroid(d);
                pos[0] = radius * 0.95 * (d.startAngle + (d.endAngle - d.startAngle) / 2 < Math.PI ? 1 : -1);
                return [arc.centroid(d), outerArc.centroid(d), pos];
            })
            .exit()
            .remove();
    }
};
const createVerticalHistogramChart = (selector, data, colors = ['#fbc02d', '#f37e36']) => {
    const barWiigth = 75;
    const maxWeight = barWiigth * data.length;
    const height = 260;
    const innerHeight = height - 30;

    if (d3.select(selector).node()) {
        d3.select(selector).selectAll('svg').remove();
        d3.select(selector).append('svg')
            .attr('class', 'w-100 overflow-visible')
            .attr('height', `${height}px`);

        let { width } = d3.select(selector).select('svg').node().getBoundingClientRect();
        let chartWidth = width > maxWeight ? maxWeight : width;

        const svg = d3.select(selector).select('svg')
            .append('g')
            .style('transform', `translate(${(width - chartWidth) / 2}px, 15px)`)
            .attr('width', `${chartWidth}px`)
            .attr('height', `${height}px`)
        ;
        svg.append('g').attr('class', 'x');
        svg.append('g').attr('class', 'y');

        const color = d3.scaleOrdinal()
            .domain(data.map(d => d.label))
            .range(colors);

        const x = d3.scaleBand()
            .domain(data.map(d => d.label))
            .rangeRound([0, chartWidth])
            .padding(0.1);

        const y = d3.scaleLinear()
            .domain([0, d3.max(data, d => d.value)])
            .rangeRound([innerHeight, 0]);

        svg.select('.x')
            .attr('transform', 'translate(0,' + innerHeight + ')')
            .call(d3.axisBottom(x))
            .selectAll('.tick text')
            .call((text, width) => wrap(text, width), x.bandwidth());

        svg.selectAll('.bar')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', 'bar')
            .attr('x', d => x(d.label))
            .attr('y', d => y(d.value))
            .attr('stroke', 'black')
            .style('stroke-width', '1px')
            .attr('fill', d => color(d.label))
            .attr('width', x.bandwidth())
            .attr('height', d => innerHeight - y(d.value));

        svg.selectAll('.bartext')
            .data(data)
            .enter()
            .append('text')
            .attr('class', 'bartext')
            .attr('x', d => x(d.label) + x.bandwidth() / 2)
            .attr('y', d => y(d.value) - 15)
            .attr('dy', '.75em')
            .style('text-anchor', 'middle')
            .style('font-size', '12px')
            .style('fill', '#838383')
            .text(d => formatValue(d.value));
    }
};
const createHorizontalHistogramChart = (selector, data, axis = 'left', colors = ['#fbc02d', '#f37e36']) => {
    const height = 260;

    if (d3.select(selector).node()) {
        d3.select(selector).selectAll('svg').remove();
        d3.select(selector).append('svg')
            .attr('class', 'w-100 overflow-visible')
            .attr('height', `${height}px`);

        let { width } = d3.select(selector).select('svg').node().getBoundingClientRect();
        let chartHeight = height;
        let chartWidth = width - 70;

        const svg = d3.select(selector).select('svg')
            .append('g')
            .attr('width', `${width}px`)
            .attr('height', `${height}px`);
        svg.append('g').attr('class', 'x');
        svg.append('g').attr('class', 'y');

        const color = d3.scaleOrdinal()
            .domain(data.map(d => d.label))
            .range(colors);

        const y = d3.scaleBand()
            .domain(data.map(d => d.label))
            .rangeRound([chartHeight, 0])
            .padding(0.1);

        const x = d3.scaleLinear()
            .domain([0, d3.max(data, d => d.value)])
            .rangeRound([60, chartWidth]);

        svg.select('.y')
            .attr('transform', 'translate(60, 0)')
            .call(d3.axisLeft(y))
            .selectAll('.tick text')
            .call((text, width) => wrap(text, width, -10), 60);

        svg.selectAll('.bar')
            .data(data)
            .enter()
            .append('rect')
            .attr('class', 'bar')
            .attr('x', 60)
            .attr('y', d => y(d.label))
            .attr('stroke', 'black')
            .style('stroke-width', '1px')
            .attr('fill', d => color(d.label))
            .attr('height', y.bandwidth())
            .attr('width', d => x(d.value));

        svg.selectAll('.bartext')
            .data(data)
            .enter()
            .append('text')
            .attr('class', 'bartext')
            .attr('y', d => y(d.label) + y.bandwidth() / 2)
            .attr('x', d => x(d.value) + 50)
            .attr('dy', '4px')
            .style('text-anchor', 'end')
            .style('font-size', '12px')
            .style('fill', '#000000')
            .text(d => formatValue(d.value));
    }
};


const renderCharts = () => {
    createHorizontalHistogramChart('#js_chart_1', [
        { label: 'Беларусь', value: 67082 },
        { label: 'Казахстан', value: 71064 },
        { label: 'Украина', value: 153703 },
        { label: 'Россия', value: 890160 },
    ]);

    createPieChart('#js_chart_2', [
        { label: 'Мужской', value: 338613 },
        { label: 'Женский', value: 549682 },
    ]);

    createHorizontalHistogramChart('#js_chart_3', [
        { label: '55-64', value: 20471 },
        { label: '45-54', value: 54287 },
        { label: '35-44', value: 157875 },
        { label: '25-34', value: 310183 },
        { label: '18-24', value: 272122 },
    ]);

    createHorizontalHistogramChart('#js_chart_4', [
        { label: 'нас.пункты до 100 тыс', value: 285445 },
        { label: 'города 100 - 250 тыс', value: 98114 },
        { label: 'города 250 - 500 тыс', value: 110570 },
        { label: 'города 500 тыс - 1 млн', value: 103142 },
        { label: 'города 1 млн+ кроме Мск и СПб', value: 160462 },
        { label: 'Санкт-Петербург', value: 42882 },
        { label: 'Москва', value: 89437 },
    ]);
};

renderCharts();
$(window).on('resize', function(){
    renderCharts();
});
